var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp301({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,14.33c-1.62,0-3.25-0.62-4.48-1.85c-2.47-2.47-2.47-6.49,0-8.96c2.47-2.47,6.49-2.47,8.96,0 c2.47,2.47,2.47,6.49,0,8.96C11.24,13.71,9.62,14.33,8,14.33z M8,2.17c-1.49,0-2.99,0.57-4.13,1.71c-2.27,2.27-2.27,5.98,0,8.25 c2.27,2.28,5.97,2.28,8.25,0c2.27-2.27,2.27-5.98,0-8.25C10.99,2.74,9.49,2.17,8,2.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 1.92,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.3137 8.0002)",
    className: "st2",
    width: 0.5,
    height: 12.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.92,
    y: 7.75,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.3137 8.0002)",
    className: "st2",
    width: 12.17,
    height: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp301);
export default __webpack_public_path__ + "static/media/Lamp3-01.4b3d3e312bbf87dd1df3019037a0e78e.svg";
export { ForwardRef as ReactComponent };